const CALENDAR_DATE = new Intl.DateTimeFormat('es-AR', { timeZone: 'UTC' });

/**
 * Formats a calendar day (`serviceDate`) as `d/m/yyyy`.
 *
 * The API sends these as UTC midnight. Formatting them in the browser's zone
 * would move every date one day back in Argentina (UTC-3), so the day is read
 * in UTC, where it was written.
 *
 * A local copy, not an import from `contracts/format-calendar-date.ts`: same
 * deliberate per-domain duplication `design.md` §6.4 already establishes
 * (`calendar/` never imports across from `contracts/`, mirroring
 * `menus/format-base-price.ts`).
 */
export function formatCalendarDate(value: string): string {
  return CALENDAR_DATE.format(new Date(value));
}
